// hooks/useBackButton.ts
import { useCallback, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { isTMA } from "@telegram-apps/sdk-react";
import { initBackButton } from "@telegram-apps/sdk";

type BackButton = {
  show: () => void;
  hide: () => void;
  on: (event: string, handler: () => void) => void;
  off: (event: string, handler: () => void) => void;
} | null;

export const useBackButton = (onClick?: () => void) => {
  const [isTma, setIsTma] = useState(false);
  const [backButton, setBackButton] = useState<BackButton>(null);
  const navigate = useNavigate();
  const location = useLocation();

  // Handle back button click
  const handleBackButtonClick = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  useEffect(() => {
    // Detect if the app is running in a TMA
    async function detectAndSetIsTMA() {
      const _isTMA = await isTMA();
      console.log("isTMA", _isTMA);
      setIsTma(_isTMA);

      if (_isTMA) {
        const [button] = initBackButton();
        setBackButton(button as BackButton);
      }
    }
    detectAndSetIsTMA();
  }, []);

  useEffect(() => {
    if (isTma && backButton && location.pathname !== "/") {
      backButton.on("click", onClick ?? handleBackButtonClick);
      backButton.show();

      return () => {
        backButton.hide();
        backButton.off("click", onClick ?? handleBackButtonClick);
      };
    }

    // Hide the back button if location is '/' or not TMA
    if (location.pathname === "/" || !isTma) {
      backButton?.hide();
    }
  }, [backButton, handleBackButtonClick, onClick, isTma, location.pathname]);
};
